import type { Project } from "./index.ts";

export const supportFeaturesHeader = "x-support-features";
export const unansweredThresholdFeature = "unanswered-threshold-v1";

/** Representation negotiation only; grants no authority or project access. */
export function supportsUnansweredThreshold(value: string | null): boolean {
  return (
    value !== null &&
    value.length <= 256 &&
    value.split(",").some((part) => part.trim() === unansweredThresholdFeature)
  );
}

export function projectForFeatures(
  project: Project,
  enabled: boolean,
): Project {
  if (enabled) return project;
  const legacy = { ...project };
  delete legacy.unansweredThresholdMinutes;
  return legacy;
}
